import * as React from 'react';
import { RouteComponentProps } from 'react-router';

interface PrivacyPolicy {
    loading: Boolean;
}

export class PrivacyPolicyData extends React.Component<RouteComponentProps<{}>, PrivacyPolicy> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false
        };
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div>
                <h1>Privacy Policy</h1>
                <br></br>
                <p>
                    Super Safe Hire is committed to providing quality services to you and this policy outlines our ongoing obligations to you in respect of how we manage your Personal Information.
                </p>
                <p>
                    We have adopted the Australian Privacy Principles (APPs) contained in the Privacy Act 1988 (Cth) (the Privacy Act). The NPPs govern the way in which we collect, use, disclose, store, secure and dispose of your Personal Information.
                </p>
                <p>
                    A copy of the Australian Privacy Principles may be obtained from the website of The Office of the Australian Information Commissioner at www.aoic.gov.au
                </p>
                <h3>
                    What is Personal Information and why do we collect it?
                </h3>
                <p>
                    Personal Information is information or an opinion that identifies an individual. Examples of Personal Information we collect include: names, email addresses and phone numbers.
                </p>
                <p>
                    Personal Information is collected when you are signed up to Dash.
                </p>
                <p>
                    We collect your Personal Information for the primary purpose of providing our services to you.
                </p>
                <h3>
                    Disclosure of Personal Information
                </h3>
                <p>
                    Your Personal Information may be disclosed where required or authorised by law.
                </p>
                <h3>
                    Security of Personal Information
                </h3>
                <p>
                    Your Personal Information is stored in a manner that reasonably protects it from misuse and loss and from unauthorized access, modification or disclosure.
                </p>
                <p>
                    When your Personal Information is no longer needed for the purpose for which it was obtained, we will take reasonable steps to destroy or permanently de-identify your Personal Information. 
                </p>
                <p>
                    However, most of the Personal Information is or will be stored in client files which will be kept by us for a minimum of 7 years.
                </p>
                <h3>
                    Access to your Personal Information
                </h3>
                <p>
                    You may access the Personal Information we hold about you and to update and/or correct it, subject to certain exceptions. If you wish to access your Personal Information, please contact us in writing.
                </p>
                <p>
                    In order to protect your Personal Information we may require identification from you before releasing the requested information.
                </p>
                <h3>
                    Maintaining the Quality of your Personal Information
                </h3>
                <p>
                    It is an important to us that your Personal Information is up to date. We  will  take reasonable steps to make sure that your Personal Information is accurate, complete and up-to-date. If you find that the information we have is not up to date or is inaccurate, please advise us as soon as practicable so we can update our records and ensure we can continue to provide quality services to you.
                </p>
                <h3>
                    Policy Updates
                </h3>
                <p>
                    This Policy may change from time to time and is available on our website.
                </p>
                <h3>
                    Privacy Policy Complaints and Enquiries
                </h3>
                <p>
                    If you have any queries or complaints about our Privacy Policy please contact us at:
                </p>
                <p>
                    Super Safe Hire
                </p>
                <p>
                    34-36 Gatwick Road, Bayswater North, VIC 3153
                </p>
                <p>
                    sales@supersafehire.com.au
                </p>

            </div>
        );

    }

};